<!-- Certificate -->
<div class="text-center">
    <h1>RentWise Certficate</h1>
</div>

<div *ngIf="error" class="text-center text-danger pb-4">{{error}}</div>

<pdf-viewer *ngIf="loaded && src" [src]="src" [render-text]="true" [original-size]="true" style="width: 100%; height: 100%; ">
</pdf-viewer>

<div class="navigate-buttons text-center pb-4" *ngIf="!loading">
    <button type="button" class="btn waves-dark w-25" [routerLink]="'/admin/rentwise-users'">Back to Users</button>
    <button type="button" class="btn waves-dark w-25" (click)="downloadPdf()" [disabled]="!src">Download PDF</button>
</div>
